export const ACCESS_TOKEN_NAME = 'access_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const DEVICE_ID = 'device_id'
export const SIGN = 'sign'
export const DATA = 'data'
// export const KEY_AES = makeid(10);
export const KEY_AES = "Vds@123452022";

function makeid(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const ActionEditor = {
  LAYOUT_SETTING: 0,
  ADD_LAYER: 1,
  EDITOR_LAYER: 2,
  PREVIEW: 3,
}

export const TypeChooseLayer = {
  TEXT: 0,
  IMAGE: 1,
  VIDEO: 2,
  PLAY_LIST: 3,
  YOUTUBE: 4,
  RSS: 5,
  DOCUMENT: 6,
  AREA_TEXT : 7,
  AREA_LEFT : 8,
  AREA_RIGHT : 9,
  FULL_SCREEN : 10,
  STREAM_VTV : 11,
  WIDGET: 12
}

export const TypePlayList = {
  TEXT_RUN : -1,
  TEXT_NORMAL : 0,
  IMAGE: 1,
  VIDEO : 2
}

export const TypeSchedule = {
  OFF: -1,
  CANCEL : 0,
  PLAY : 1
}

export const ShakaPlayerConfig = {
  MAXATTEMPTS: 100000,
  BASEDELAY: 10000
}






// WEBPACK FOOTER //
// ./src/constant.js